import {ReactNode} from 'react';

import {HStack, Spinner, SpinnerProps, StackProps} from '@chakra-ui/react';

interface ShowSpinnerWhileProps extends StackProps {
  condition: boolean;
  spinnerSize?: SpinnerProps['size'];
  children?: ReactNode;
}

export function ShowSpinnerWhile(props: Readonly<ShowSpinnerWhileProps>) {
  const {condition, spinnerSize, children, ...stackProps} = props;
  if (!condition) {
    return (
      <HStack flex={1} w='100%' justifyContent='center' {...stackProps}>
        <Spinner size={spinnerSize ?? 'md'} />
      </HStack>
    );
  }

  return <>{children}</>;
}
